export const categoryItems = [
  "Laundry & Fabric Care",
  "Refills",
  "Dish & Kitchen",
  "Hand Washes",
  "Floor, Surface & Home Cleaners",
  "Cleaning Accessories",
  "Fresheners & Fragrances",
  "Baby Cleaners",
  "Pet Cleaners",
];
export const navItems = [
  "Media Coverage",
  "Blogs",
  "New Launches",
  "Track Order",
  "Contact Us",
  "About",
];